'use strict';

angular.module('licensure.services')
    .factory('ServiceUserTrainings', ['$http', '$q', function ($http, $q) {
        var save = function (service_user_training) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/ServiceUserTrainings/';
            if (!isUndefined(service_user_training.id)) {
                method = 'PUT'
                url += service_user_training.id
            }

            $http({
                method: method,
                url: url,
                data: {
                    service_user_training: service_user_training
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserTrainings', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserTrainings/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: save,

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/ServiceUserTrainings/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            saveElement: function (answers, licenseRequestID) {
                var d = $q.defer();
                var reimbursements = [];

                answers.forEach(function (answer) {
                    if (answer.reimburse && answer.license_request_id != null && answer.service_id != null && answer.user_id != null && answer.training_id != null) {
                        var saveAnswer = angular.copy(answer);
                        saveAnswer.training = null;
                        saveAnswer.trainings = null;
                        reimbursements.push(saveAnswer);
                    }
                });

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/ServiceUserTrainings/saveElement',
                    data: {
                        service_user_trainings: reimbursements,
                        license_request_id: licenseRequestID
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;